<div class="mention-abbr" [ngClass]="{mention__big: !pequeno}" [ngStyle]="{'background-image': imgBGStyle}" [matTooltip]="toolTip"
matTooltipPosition="left">{{display}}</div>

